import { ArrowUp, Instagram, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_URL, MAPS_URL } from "./data";
import { scrollToId } from "./lib";

const LINKS = [
  ["Menu", "menu"],
  ["Story", "story"],
  ["Reviews", "reviews"],
  ["Visit", "visit"],
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-obsidian pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div
          data-testid="footer-wordmark"
          className="text-outline font-display font-bold uppercase leading-none text-[10.5vw] md:text-[11.5vw] whitespace-nowrap select-none"
        >
          Nuun Kebabs
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map(([label, id]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim hover:text-ember transition-colors"
              >
                {label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-gold px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/85 transition-colors"
            >
              <Instagram className="w-4 h-4 text-gold" />
              @nuunkebabs.mlr
            </a>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-directions-link"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-gold px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/85 transition-colors"
            >
              Maps
              <ArrowUpRight className="w-4 h-4" />
            </a>
            <button
              data-testid="footer-back-to-top"
              aria-label="Back to top"
              onClick={() => scrollToId("home")}
              className="flex h-11 w-11 items-center justify-center rounded-full bg-ember hover:bg-emberglow text-charcoal transition-all duration-300 hover:-translate-y-0.5"
            >
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.22em] text-dim/60">
          <span>© Nuun Kebabs · Mangaluru</span>
          <span className="hidden md:inline">Charcoal · Smoke · Fire</span>
          <span className="font-arabic text-lg normal-case tracking-normal text-ember/70">
            نون
          </span>
        </div>
      </div>
    </footer>
  );
}
